<div class="contacts">
  <div class="contacts__table--overflow-container">
    <table mat-table [dataSource]="tableData" matSort class="contacts__table">
      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-left">Name</th>
        <td mat-cell *matCellDef="let contact" class="mat-column-left">
          <b>{{ contact.firstName }} {{ contact.lastName }}</b>
        </td>
      </ng-container>

      <ng-container matColumnDef="phone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-center">Phone</th>
        <td mat-cell *matCellDef="let contact" class="mat-column-center">{{ contact.phone }}</td>
      </ng-container>

      <ng-container matColumnDef="mobile">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-center">Mobile</th>
        <td mat-cell *matCellDef="let contact" class="mat-column-center">{{ contact.mobile }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-center">Email</th>
        <td mat-cell *matCellDef="let contact" class="mat-column-center">{{ contact.email }}</td>
      </ng-container>

      <ng-container matColumnDef="positionHeld">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-center">Position Held</th>
        <td mat-cell *matCellDef="let contact" class="mat-column-center">{{ contact.positionHeld }}</td>
      </ng-container>

      <ng-container matColumnDef="isRegulatoryContact">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-center">Regulatory Contact?</th>
        <td mat-cell *matCellDef="let contact" class="mat-column-center">{{ contact.isRegulatoryContact ? 'YES' : 'NO' }}</td>
      </ng-container>

      <ng-container matColumnDef="hasOnlineAccess">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-center">Online access</th>
        <td mat-cell *matCellDef="let contact" class="mat-column-center online-access">
          {{ contact.hasOnlineAccess ? 'YES' : 'NO' }}
          @if (contact.hasOnlineAccess && contact.accountPermissions > 0) {
            <mat-icon [matTooltip]="showPermissions(contact)" class="online-access__help">info</mat-icon>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="mat-column-center">Actions</th>
        <td mat-cell *matCellDef="let contact" class="mat-button-column mat-column-center">
          <div class="action-buttons">
            <button
              mat-raised-button
              matTooltip="{{ contact.hasActiveLicences ? 'This contact has active licences' : '' }}"
              class="button--secondary"
              (click)="navigateToRemoveContact(contact)"
            >
              {{ contact.hasActiveLicences ? 'Request Deletion' : 'Delete' }}
            </button>
            <button mat-raised-button class="button--primary" [routerLink]="['/accounts/details/contacts/edit', contact.lcAuto]">Details</button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
    </table>
  </div>

  <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
</div>
<div class="contacts__footer">
  <button mat-raised-button routerLink="/accounts/details/contacts/new">ADD CONTACT</button>
</div>
